import classNames from 'classnames';
import React, { FC } from 'react';

import styles from './PopupHeaderSteps.style.m.css';

interface IPopupHeaderStepsProps {
  stepsCount: number;
  currentStep?: number;
}

export const PopupHeaderSteps: FC<IPopupHeaderStepsProps> = ({ stepsCount, currentStep = 1 }) => {
  return (
    <div className={styles.container}>
      {Array.from({ length: stepsCount }, (_, index) => (
        <div
          key={index}
          className={classNames(styles.step, {
            [styles.stepActive]: currentStep >= index + 1,
          })}
        />
      ))}
    </div>
  );
};
